import {Decoder, field, number, object, string} from 'json-bouncer'
import {nullableWithDefaultDecoder} from '../Data/DecodeHelper'

export interface Company {
    id: number
    name1: string
    name2: string
    invoiceName3: string
    invoiceName4: string
    invoiceStreet: string
    invoiceHouseNumber: string
    invoiceZipCode: string
    invoiceCity: string
    invoiceCountry: string
    deliveryName3: string
    deliveryName4: string
    deliveryStreet: string
    deliveryHouseNumber: string
    deliveryZipCode: string
    deliveryCity: string
    deliveryCountry: string
    vatId: string
}

export function companyDecoder(): Decoder<Company> {
    return object({
        id: field('id', number()),
        name1: field('name1', string()),
        name2: field('name2', nullableWithDefaultDecoder('', string())),
        invoiceName3: field('invoiceName3', nullableWithDefaultDecoder('', string())),
        invoiceName4: field('invoiceName4', nullableWithDefaultDecoder('', string())),
        invoiceStreet: field('invoiceStreet', nullableWithDefaultDecoder('', string())),
        invoiceHouseNumber: field('invoiceHouseNumber', nullableWithDefaultDecoder('', string())),
        invoiceZipCode: field('invoiceZipCode', nullableWithDefaultDecoder('', string())),
        invoiceCity: field('invoiceCity', nullableWithDefaultDecoder('', string())),
        invoiceCountry: field('invoiceCountry', nullableWithDefaultDecoder('', string())),
        deliveryName3: field('deliveryName3', nullableWithDefaultDecoder('', string())),
        deliveryName4: field('deliveryName4', nullableWithDefaultDecoder('', string())),
        deliveryStreet: field('deliveryStreet', string()),
        deliveryHouseNumber: field('deliveryHouseNumber', string()),
        deliveryZipCode: field('deliveryZipCode', string()),
        deliveryCity: field('deliveryCity', string()),
        deliveryCountry: field('deliveryCountry', string()),
        vatId: field('vatId', nullableWithDefaultDecoder('', string())),
    })
}

export function label(company: Company): string {
    return `${company.name1} ${company.name2}`
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Company.ts